import type { SectionConfig } from "@/v2/framework/registry/types";

export default {
  name: "metadata",
  title: "navigation.settings.metadata",
  position: 1,
} satisfies SectionConfig;
